import { render, staticRenderFns } from "./changeSubject.vue?vue&type=template&id=4fd06221&scoped=true&"
import script from "./changeSubject.vue?vue&type=script&lang=js&"
export * from "./changeSubject.vue?vue&type=script&lang=js&"
import style0 from "./changeSubject.vue?vue&type=style&index=0&id=4fd06221&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd06221",
  null
  
)

export default component.exports